import { useSelector, useDispatch } from "react-redux";
import { getMessageActions, messageActions } from "./actions.js";
import { messageSelector, valuesSelector, modeSelector } from "./selectors.js";
function useReduxMessage() {
  const message = useSelector(messageSelector);
  const messageValues = useSelector(valuesSelector);
  const mode = useSelector(modeSelector);
  const dispatch = useDispatch();
  const { clearMessage } = getMessageActions();
  const clearMessages = () => dispatch(clearMessage());
  return {
    message,
    messageValues,
    mode,
    clearMessages
  };
}
function useMessage() {
  const dispatch = useDispatch();
  function showMessage(message) {
    dispatch(messageActions.saveMessage(message));
  }
  return { showMessage };
}
export {
  useMessage,
  useReduxMessage
};
//# sourceMappingURL=hooks.js.map
